import cookieUtil from 'static/script/utils/cookie';

var userPreferences = (function () {

    let cookieName = 'UserPreferences';

    function getPreferences() {
        let json = userPreferences.cookieUtil.readCookie(cookieName);
        if (json) {
            return JSON.parse(json);
        } else {
            return {};
        }
    }

    function savePreferences(name, value) {
        let preferences = getPreferences();
        preferences[name] = value;

        let date = new Date();
        date.setMonth(date.getMonth() + 1);
        userPreferences.cookieUtil.createCookie(cookieName, JSON.stringify(preferences), date);
    }

    return {
        get: function (name) {
            return getPreferences()[name] || '';
        },
        set: function (name, value) {
            savePreferences(name, value);
        }
    };

}());

userPreferences.cookieUtil = cookieUtil;

export default userPreferences;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/user-preferences.js